/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserAccessType } from './UserAccessType';
import {
    UserAccessTypeFromJSON,
    UserAccessTypeFromJSONTyped,
    UserAccessTypeToJSON,
    UserAccessTypeToJSONTyped,
} from './UserAccessType';

/**
 * 
 * @export
 * @interface AccessMetaDataResponse
 */
export interface AccessMetaDataResponse {
    /**
     * 
     * @type {UserAccessType}
     * @memberof AccessMetaDataResponse
     */
    type?: UserAccessType;
    /**
     * 
     * @type {string}
     * @memberof AccessMetaDataResponse
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessMetaDataResponse
     */
    orgType?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AccessMetaDataResponse
     */
    code?: string | null;
}



/**
 * Check if a given object implements the AccessMetaDataResponse interface.
 */
export function instanceOfAccessMetaDataResponse(value: object): value is AccessMetaDataResponse {
    return true;
}

export function AccessMetaDataResponseFromJSON(json: any): AccessMetaDataResponse {
    return AccessMetaDataResponseFromJSONTyped(json, false);
}

export function AccessMetaDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessMetaDataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : UserAccessTypeFromJSON(json['type']),
        'name': json['name'] === undefined ? undefined : json['name'] === null ? null : json['name'],
        'orgType': json['orgType'] === undefined ? undefined : json['orgType'] === null ? null : json['orgType'],
        'code': json['code'] === undefined ? undefined : json['code'] === null ? null : json['code'],
    };
}

export function AccessMetaDataResponseToJSON(json: any): AccessMetaDataResponse {
    return AccessMetaDataResponseToJSONTyped(json, false);
}

export function AccessMetaDataResponseToJSONTyped(value?: AccessMetaDataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': UserAccessTypeToJSON(value['type']),
        'name': value['name'],
        'orgType': value['orgType'],
        'code': value['code'],
    };
}

